import React from 'react'
import { useLocation } from 'react-router-dom';
class Menulist extends React.Component{

    constructor() {
        super();
        this.state = {
          hobbies: [],
          tid: '',
          messagelog: '',
          isLoading: true,
          users: [],
          numberstid: [],
          error: null
        }
    }

    logOut() {
        localStorage.clear();
    
        window.location.reload();
      }
    
render(){
    const c=this.props.samircallback;

return(
    <div className="aside-bar"> 
    <ul className="vertical tabs menu-tabs" > 
   
    {this.props.samircallback ==="/mypage" ? <li className="tabs-title is-active"><a href="#/mypage"> <span><i className="icomoon-icon icon-news"></i> إدارة أخباري</span> </a></li> : <li className="tabs-title "><a href="#/mypage"> <span><i className="icomoon-icon icon-news"></i> إدارة أخباري</span> </a></li>} 

    {this.props.samircallback ==="/my_newsletter" ?  <li  className="tabs-title is-active"><a href="#/my_newsletter"> <span><i className="icomoon-icon icon-envelop1"></i>نشراتي البريدية</span></a></li> :  <li  className="tabs-title"><a href="#/my_newsletter"> <span><i className="icomoon-icon icon-envelop1"></i>نشرتي البريدية</span></a></li>} 
    {this.props.samircallback ==="/editprofile" ?  <li className="tabs-title is-active"><a href="#/editprofile"> <span><i className="icomoon-icon icon-user-circle-o"></i>تفاصيل حسابي </span> </a></li> :  <li className="tabs-title"><a href="#/editprofile"> <span><i className="icomoon-icon icon-user-circle-o"></i>تفاصيل حسابي </span> </a></li>} 
    </ul> 
    <ul className="menu vertical menu-tabs"> 
    <li className="logout"><button className="button submit-btn" onClick={this.logOut} ><i className="icomoon-icon icon-sign-out"></i>خروج </button></li>
    </ul> 
</div>
)  
}
}
export default Menulist;